<template>
    <div class="page-iframe">
        <div class="iframe-main">
            <YScroll style="height: 100%;">
                <iframe id="agriHomeworkDetailsFrame" :src="'/admin/iframe/ny/AddHomework/request?id=' + id + '&mode=' + mode"
                    style="width: 100%;height: 700px; " />
            </YScroll>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';

export default {
    components: { YScroll },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        mode: {
            type: String,
            default: 'add',
        },
    },
    data () {
        return {
        };
    },
    watch: {

    },
    created () { },

    mounted () {

    },
    methods: {

    },
};
</script>

<style lang="scss">
.page-iframe {
    width: 100%;
    height: calc(100vh - 20vh - 58px);
    box-sizing: border-box;

    .iframe-main {
        width: 100%;
        height: 100%; // 占满父容器高度
    }

}
</style>
